import type { RouteObject } from "react-router"

export const rolesRoutes: RouteObject[] = [
  {
    path: "roles",
    lazy: () => import("./roles-page").then((m) => ({ Component: m.RolesPage })),
  },
]
